import { render, staticRenderFns } from "./BreakdownTotalSwitcher.vue?vue&type=template&id=0a30ffb3"
import script from "./BreakdownTotalSwitcher.vue?vue&type=script&lang=js"
export * from "./BreakdownTotalSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports